import { AutocompleteItem, AutocompleteResponse, AutocompleteSearchEntityType } from "@habity/types/autocomplete";
import { getAPI } from "~/lib/api";

export const searchEntityTypesByText = async (query: string, entityTypes?: AutocompleteSearchEntityType[]): Promise<AutocompleteItem[] | null> => {
  try {
    const queryParams = `query=${encodeURIComponent(query)}`;
    const entityTypesParam = entityTypes
      ? entityTypes.map(type => `&entityTypes=${encodeURIComponent(type)}`).join('')
      : '';
    const response: AutocompleteResponse = await getAPI('/providers/supabase/autocomplete', queryParams + entityTypesParam);
    if (!response) {
      console.error('No response from API');
      return null;
    }
    const { data, error } = response;
    if (error) {
      console.error('Error fetching autocomplete results:', error);
      return null;
    }
    return data;
  } catch (error) {
    console.error('Error fetching autocomplete results:', error);
    return null;
  }
};
